"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogicalTable = void 0;
/**
 * Implementation of a logical table.
 * This does not follow the Impl pattern as it is just a property bag.
 */
class LogicalTable {
    constructor(_logicalTable) {
        this._logicalTable = _logicalTable;
    }
    get id() {
        return this._logicalTable.id;
    }
    get caption() {
        return this._logicalTable.caption;
    }
}
exports.LogicalTable = LogicalTable;
//# sourceMappingURL=LogicalTable.js.map